export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-v1-480-ba2b8041d851a3fe1631d172c2fadd14.png";